"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProduction = void 0;
/**
 * Determines if the environment is production
 *
 * AFAIK, there is no standardized method to determine the environment in browser
 * We are relied on the fact that bundling tool often replace the value of `process.env.NODE_ENV`
 * with the actual environment value based on the build command
 *
 * Decided to not use `process.env.NODE_ENV === 'production'`
 * to avoid false negative, for example - `prod`, which is more dangerous than false positive in our case
 *
 * @returns true if the environment is production, false otherwise
 */
function isProduction() {
    return process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test';
}
exports.isProduction = isProduction;
